import { createReducer } from "@reduxjs/toolkit";
import {
  DESIGN_ERROR,
  DESIGN_LOADING,
  CREATE_DESIGN,
  EDIT_DESIGN,
  LIST_DESIGN,
  DELETE_DESIGN,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const designReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(DESIGN_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(DESIGN_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(LIST_DESIGN, (state, { payload }) => {
      state.data = payload.data;
      state.loading = false;
    })
    .addCase(CREATE_DESIGN, (state, { payload }) => {
      Array.isArray(state.data)
        ? state.data.push(payload)
        : (state.data = [payload]);
      state.loading = false;
    })
    .addCase(EDIT_DESIGN, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    })
    .addCase(DELETE_DESIGN, (state, { payload }) => {
      state.data = state.data.filter((e) => e?.id !== payload?.id);
      state.loading = false;
    });
});

export default designReducer;
